<div *ngIf="currentUser">

  <div class="section-title">
    <div class="row">
      <div class="col">
        <h3>Account</h3>
        <p>Keep your account settings up to date.</p>
      </div>
    </div>
  </div>

  <br/>

  <div class="section-account-details">

    <div class="row row-cols-2">
      <div class="col-auto">
        <div>
          <a (click)="openUpdateProfileImageModal()">
            <img [src]="currentUser.image ? currentUser.image.filePath : '/images/settings/settings-account/profile-default.png'" class="img-responsive img-circle" style="width: 120px" alt="Profile picture">
          </a>
        </div>


        <br/>

        <div>
          <div class="text-center">
            <button class="btn p-0 ms-2" style="color: deepskyblue" (click)="openProfileModal()">(edit profile)</button>
          </div>
        </div>
      </div>

      <div class="col">
        <p class="m-0">
          <span>Name</span>
          <span><button class="btn p-0 ms-2" style="color: deepskyblue" (click)="openUpdateNameModal()">(edit)</button></span>
        </p>
        <h4>{{ currentUser.firstName }} {{ currentUser.lastName }}</h4>
        <br/>

        <p class="m-0">
          <span>Email</span>
          <span><button class="btn p-0 ms-2" style="color: deepskyblue" (click)="openUpdateEmailModal()">(edit)</button></span>
        </p>
        <h4>{{ currentUser.email }}</h4>

        <br/>

        <p class="m-0">
          <span>Password</span>
          <span><button class="btn p-0 ms-2" style="color: deepskyblue" (click)="openUpdatePasswordModal()">(edit)</button></span>
        </p>
        <h4>(hidden)</h4>
      </div>
    </div>

    <br/>
  </div>

  <br/>

  <div class="section-payment-methods" *ngIf="currentUser.role === 'customer' && !currentUser.company">
    <br/>
    <br/>

    <h3>Payment methods</h3>
    <hr/>

    <br/>

    <!-- Existing payment methods -->
    <app-payment-methods [userId]="currentUser._id!"/>

  </div>

  <br/>
  <br/>
  <br/>

</div>
